module.exports = __webpack_public_path__ + "img/pm25_es.0501d94b.jpg";